import React from 'react';
import { Button, Card, Typography, Space, Divider } from 'antd';
import { ArrowLeftOutlined, MailOutlined, SafetyOutlined, LockOutlined, EyeOutlined, FileTextOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1); // Geri git
  };

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      {/* Header */}
      <Card style={{ marginBottom: '24px', textAlign: 'center' }}>
        <Space direction="vertical" size="small">
          <Button 
            type="link" 
            icon={<ArrowLeftOutlined />} 
            onClick={handleBack}
            style={{ alignSelf: 'flex-start' }}
          >
            Geri Dön
          </Button>
          <Title level={2} style={{ color: '#1890ff', margin: 0 }}>
            🔒 Gizlilik Politikası
          </Title>
          <Text type="secondary" style={{ fontStyle: 'italic' }}>
            Son Güncelleme: Ocak 2025
          </Text>
        </Space>
      </Card>

      {/* Content */}
      <Card>
        {/* Hangi Verileri Topluyoruz */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FileTextOutlined /> Hangi Verileri Topluyoruz?
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Hesap bilgileri (kullanıcı adı, email, şifre)</li>
              <li>Şirket bilgileri (şirket adı, iletişim kişisi, telefon)</li>
              <li>Sipariş verileri (sipariş detayları, durum bilgileri)</li>
              <li>İş dosyaları (yüklediğiniz PDF dosyalar)</li>
            </ul>
          </Paragraph>
        </div>

        {/* Verileri Neden Kullanıyoruz */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <EyeOutlined /> Verileri Neden Kullanıyoruz?
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Sipariş takip sistemi hizmetini sağlamak</li>
              <li>Kullanıcı hesaplarını yönetmek</li>
              <li>İş süreçlerinizi organize etmek</li>
              <li>Sistem güvenliğini korumak</li>
            </ul>
          </Paragraph>
        </div>

        {/* Verileri Paylaşıyor muyuz */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SafetyOutlined /> Verileri Paylaşıyor muyuz?
          </Title>
          <Card 
            style={{ 
              background: 'linear-gradient(135deg, #f6ffed, #d9f7be)', 
              borderLeft: '4px solid #52c41a',
              marginBottom: '16px'
            }}
          >
            <Text strong style={{ color: '#389e0d' }}>
              Hayır! Verilerinizi hiçbir üçüncü tarafla paylaşmayız, satmayız veya kiralamayız.
            </Text>
          </Card>
          <Paragraph>
            Verileriniz sadece kendi organizasyonunuzdaki yetkili kişilerle paylaşılır.
          </Paragraph>
        </div>

        {/* Verileriniz Güvende mi */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <LockOutlined /> Verileriniz Güvende mi?
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Tüm veriler şifrelenmiş olarak saklanır</li>
              <li>HTTPS ile güvenli veri transferi</li>
              <li>JWT token ile güvenli oturum yönetimi</li>
              <li>Yetkisiz erişime karşı koruma</li>
            </ul>
          </Paragraph>
        </div>

        {/* Haklarınız */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SafetyOutlined /> Haklarınız
          </Title>
          <Paragraph>
            <ul style={{ paddingLeft: '20px' }}>
              <li>Verilerinizi görme hakkı</li>
              <li>Yanlış verileri düzeltme hakkı</li>
              <li>Verilerinizi silme hakkı</li>
              <li>Veri işlemeye itiraz etme hakkı</li>
            </ul>
          </Paragraph>
        </div>

        {/* İletişim */}
        <div style={{ marginBottom: '32px' }}>
          <Title level={3} style={{ color: '#1890ff', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MailOutlined /> İletişim
          </Title>
          <Card style={{ background: '#f0f9ff', borderLeft: '4px solid #1890ff' }}>
            <Paragraph>Sorularınız için:</Paragraph>
            <Paragraph>
              <MailOutlined /> <a href="mailto:iletisim@siparify.com">iletisim@siparify.com</a>
            </Paragraph>
          </Card>
        </div>

        {/* Footer */}
        <Divider />
        <div style={{ textAlign: 'center' }}>
          <Paragraph type="secondary" style={{ fontStyle: 'italic' }}>
            Bu politika KVKK ve GDPR gerekliliklerine uygun olarak hazırlanmıştır.
          </Paragraph>
          <Text strong style={{ color: '#1890ff' }}>
            Siparify © 2025
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default PrivacyPolicyPage;